/**
 * Plan D-11. These live below hooks/ because utils/uploadBatch.ts needs them and
 * §5.1's rule is that nothing below hooks/ imports React — which importing them
 * from the hook file would violate transitively. This module imports nothing.
 */

export enum UploadStatus {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS',
  Failed = 'FAILED',
  /**
   * Plan D-15. develop's enum has four members (types.ts:25-30) and its own
   * DicomUploadProgressItem references a fifth that does not exist (§6 defect 16).
   * §5.4 makes cancellation a real terminal state, so the member is added.
   */
  Cancelled = 'CANCELLED',
}

/**
 * Plan D-9. Render state only — no File, no uploader instance, no unsubscribe
 * closure. develop put all three inside reducer state (useDicomUpload.ts:15-23),
 * which is what let its Continue path mutate `remainingFiles[0].uploader` in place
 * (:174-175) and see nothing re-render.
 */
export interface UploadRow {
  name: string;
  size: number;
  status: UploadStatus;
  /** 0-100. */
  progress: number;
  error?: string;
}
